export class Domain {
    _id;
    name;
    title;
    reseller;
    administrators;
    active;
    deleted;
}
export class ResellerDomainFilter {
    _id;
    name;
    title;
    administrators;
    active;
    deleted;
}
export class DomainFilter extends ResellerDomainFilter {
    reseller;
}
export class CreateResellerDomain {
    name;
    title;
}
export class CreateDomain extends CreateResellerDomain {
    reseller;
    administrators;
}
export class UpdateDomain {
    name;
    title;
    reseller;
    administrators;
    active;
    deleted;
}
